import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  FaBars, 
  FaTimes, 
  FaPhoneAlt, 
  FaFacebookF, 
  FaYoutube, 
  FaCaretDown 
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import './Navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  
  // Get current route to highlight parent dropdowns
  const location = useLocation();

  // Check if dropdown child pages are active
  const isAboutActive = ['/about/mission-vision', '/about/members', '/about/constitution'].includes(location.pathname);
  const isHistoryActive = ['/history/rajput-shiksha-kosh', '/history/ideal-history'].includes(location.pathname);
  const isPratibhaActive = location.pathname.startsWith('/pratibha-khoj');
  const isDonorActive = ['/donor', '/protsahan-nidhi'].includes(location.pathname);
  const isMediaActive = ['/news', '/gallery', '/events', '/event'].includes(location.pathname);

  // Toggle mobile dropdowns
  const toggleDropdown = (menu) => {
    setActiveDropdown(activeDropdown === menu ? null : menu);
  };

  // Close sidebar on link click
  const closeMenu = () => {
    setMenuOpen(false);
    setActiveDropdown(null);
  };

  return (
    <header className="navbar-component-wrapper">
      {/* ===== Top Bar ===== */}
      <div className="navbar-component-top-bar">
        <div className="navbar-component-top-container">
          <div className="navbar-component-contact-info">
            <FaPhoneAlt className="navbar-component-contact-icon" />
            <span>CALL US : +91-9414133996</span>
          </div>
          <div className="navbar-component-social-icons">
            <a href="#" className="navbar-component-fb-icon" aria-label="Facebook"><FaFacebookF /></a>
            <a href="#" className="navbar-component-x-icon" aria-label="X (Twitter)"><FaXTwitter /></a>
            <a href="#" className="navbar-component-yt-icon" aria-label="YouTube"><FaYoutube /></a>
          </div>
        </div>
      </div>

      {/* ===== Main Navigation Bar ===== */}
      <div className="navbar-component-main-bar">
        <div className="navbar-component-main-container">
          
          {/* Left: Name / Branding */}
          <div className="navbar-component-branding">
            <div className="navbar-component-names">
              <h1 className="navbar-component-name-english">RAJPUT SHIKSHA KOSH</h1>
              <h2 className="navbar-component-name-hindi">राजपूत शिक्षा कोष</h2>
            </div>
          </div>

          {/* Right: Nav Links & Action Buttons */}
          <div className="navbar-component-right-section">
            <nav className="navbar-component-desktop-nav">
              <ul className="navbar-component-desktop-menu">
                <li>
                  <NavLink end to="/" className={({ isActive }) => isActive ? "navbar-component-nav-link active" : "navbar-component-nav-link"}>
                    HOME
                  </NavLink>
                </li>
                
                {/* About Us Dropdown */}
                <li className="navbar-component-dropdown">
                  <span className={`navbar-component-nav-link navbar-component-dropdown-title ${isAboutActive ? 'active' : ''}`}>
                    ABOUT US <FaCaretDown className="navbar-component-drop-icon"/>
                  </span>
                  <ul className="navbar-component-dropdown-menu">
                    <li><NavLink to="/about/mission-vision" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>MISSION/VISION</NavLink></li>
                    <li><NavLink to="/about/members" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>MEMBERS</NavLink></li>
                    <li><NavLink to="/about/constitution" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>CONSTITUTION/DEED</NavLink></li>
                    <li><NavLink to="/about/annual-report" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>ANNUAL REPORT</NavLink></li>
                  </ul>
                </li>

                {/* History Dropdown */}
                <li className="navbar-component-dropdown">
                  <span className={`navbar-component-nav-link navbar-component-dropdown-title ${isHistoryActive ? 'active' : ''}`}>
                    HISTORY <FaCaretDown className="navbar-component-drop-icon"/>
                  </span>
                  <ul className="navbar-component-dropdown-menu">
                    <li><NavLink to="/history/rajput-shiksha-kosh" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>RAJPUT SHIKSHA KOSH</NavLink></li>
                    <li><NavLink to="/history/ideal-history" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>IDEAL OF RAJPUT SHIKSHA KOSH</NavLink></li>
                  </ul>
                </li>

                {/* Pratibha Khoj Dropdown */}
                <li className="navbar-component-dropdown">
                  <span className={`navbar-component-nav-link navbar-component-dropdown-title ${isPratibhaActive ? 'active' : ''}`}>
                    PRATIBHA KHOJ <FaCaretDown className="navbar-component-drop-icon"/>
                  </span>
                  <ul className="navbar-component-dropdown-menu">
                    <li><NavLink to="/pratibha-khoj/pariksha" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>PRATIBHA KHOJ PARIKSHA</NavLink></li>
                    <li><NavLink to="/pratibha-khoj/scholarship-procedure" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>SCHOLARSHIP PROCEDURE</NavLink></li>
                    <li><NavLink to="/pratibha-khoj/scholars-list" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>SCHOLAR'S LIST</NavLink></li>
                  </ul>
                </li>

                {/* Donor Dropdown */}
                <li className="navbar-component-dropdown">
                  <span className={`navbar-component-nav-link navbar-component-dropdown-title ${isDonorActive ? 'active' : ''}`}>
                    DONOR <FaCaretDown className="navbar-component-drop-icon"/>
                  </span>
                  <ul className="navbar-component-dropdown-menu">
                    <li><NavLink to="/donor" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>DONOR</NavLink></li>
                    <li><NavLink to="/protsahan-nidhi" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>प्रोत्साहन निधि</NavLink></li>
                  </ul>
                </li>
                
                {/* Media Dropdown */}
                <li className="navbar-component-dropdown">
                  <span className={`navbar-component-nav-link navbar-component-dropdown-title ${isMediaActive ? 'active' : ''}`}>
                    MEDIA <FaCaretDown className="navbar-component-drop-icon"/>
                  </span>
                  <ul className="navbar-component-dropdown-menu">
                    <li><NavLink to="/gallery" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>GALLERY</NavLink></li>
                    <li><NavLink to="/news" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>NEWS</NavLink></li>
                    <li><NavLink to="/events" className={({ isActive }) => isActive ? "navbar-component-drop-link active" : "navbar-component-drop-link"}>EVENTS</NavLink></li>
                  </ul>
                </li>

                <li><NavLink to="/expenses" className={({ isActive }) => isActive ? "navbar-component-nav-link active" : "navbar-component-nav-link"}>EXPENSE</NavLink></li>
                <li><NavLink to="/contact" className={({ isActive }) => isActive ? "navbar-component-nav-link active" : "navbar-component-nav-link"}>CONTACT</NavLink></li>
              </ul>
            </nav>

            {/* Action Buttons */}
            <div className="navbar-component-action-buttons navbar-component-desktop-actions">
              <NavLink to="/donate-now" className={({ isActive }) => isActive ? "navbar-component-btn active" : "navbar-component-btn"}>
                DONATE NOW
              </NavLink>
              <NavLink to="/donate-protsahan-nidhi" className={({ isActive }) => isActive ? "navbar-component-btn active" : "navbar-component-btn"}>
                प्रोत्साहन निधि
              </NavLink>
            </div>

            {/* Mobile Menu Toggle */}
            <div className="navbar-component-mobile-toggle" onClick={() => setMenuOpen(true)}>
              <FaBars />
            </div>
          </div>
        </div>
      </div>

      {/* ===== Mobile Sidebar ===== */}
      <div className={`navbar-component-sidebar ${menuOpen ? 'open' : ''}`}>
        <div className="navbar-component-sidebar-header">
          <div className="navbar-component-names">
            <h1 className="navbar-component-name-english sidebar-title">RAJPUT SHIKSHA KOSH</h1>
          </div>
          <FaTimes className="navbar-component-close-icon" onClick={closeMenu} />
        </div>

        {/* Mobile Action Buttons */}
        <div className="navbar-component-sidebar-actions">
          <NavLink to="/donate-now" onClick={closeMenu} className={({ isActive }) => isActive ? "navbar-component-btn navbar-component-full-width active" : "navbar-component-btn navbar-component-full-width"}>
            DONATE NOW
          </NavLink>
          <NavLink to="/donate-protsahan-nidhi" onClick={closeMenu} className={({ isActive }) => isActive ? "navbar-component-btn navbar-component-full-width active" : "navbar-component-btn navbar-component-full-width"}>
            प्रोत्साहन निधि
          </NavLink>
        </div>

        <ul className="navbar-component-sidebar-menu">
          <li><NavLink end to="/" onClick={closeMenu} className={({ isActive }) => isActive ? "navbar-component-mobile-link active" : "navbar-component-mobile-link"}>HOME</NavLink></li>

          {/* Mobile About Us Dropdown */}
          <li className="navbar-component-sidebar-dropdown-item">
            <div className={`navbar-component-sidebar-toggle ${isAboutActive ? 'active' : ''}`} onClick={() => toggleDropdown('about')}>
              ABOUT US <FaCaretDown className={`navbar-component-drop-icon ${activeDropdown === 'about' ? 'rotate' : ''}`} />
            </div>
            <ul className={`navbar-component-sidebar-submenu ${activeDropdown === 'about' ? 'show' : ''}`}>
              <li><NavLink to="/about/mission-vision" onClick={closeMenu}>MISSION/VISION</NavLink></li>
              <li><NavLink to="/about/members" onClick={closeMenu}>MEMBERS</NavLink></li>
              <li><NavLink to="/about/constitution" onClick={closeMenu}>CONSTITUTION/DEED</NavLink></li>
              <li><NavLink to="/about/annual-report" onClick={closeMenu}>ANNUAL REPORT</NavLink></li>
            </ul>
          </li>

          {/* Mobile History Dropdown */}
          <li className="navbar-component-sidebar-dropdown-item">
            <div className={`navbar-component-sidebar-toggle ${isHistoryActive ? 'active' : ''}`} onClick={() => toggleDropdown('history')}>
              HISTORY <FaCaretDown className={`navbar-component-drop-icon ${activeDropdown === 'history' ? 'rotate' : ''}`} />
            </div>
            <ul className={`navbar-component-sidebar-submenu ${activeDropdown === 'history' ? 'show' : ''}`}>
              <li><NavLink to="/history/rajput-shiksha-kosh" onClick={closeMenu}>RAJPUT SHIKSHA KOSH</NavLink></li>
              <li><NavLink to="/history/ideal-history" onClick={closeMenu}>IDEAL OF RAJPUT SHIKSHA KOSH</NavLink></li>
            </ul>
          </li>

          {/* Mobile Pratibha Khoj Dropdown */}
          <li className="navbar-component-sidebar-dropdown-item">
            <div className={`navbar-component-sidebar-toggle ${isPratibhaActive ? 'active' : ''}`} onClick={() => toggleDropdown('pratibha')}>
              PRATIBHA KHOJ <FaCaretDown className={`navbar-component-drop-icon ${activeDropdown === 'pratibha' ? 'rotate' : ''}`} />
            </div>
            <ul className={`navbar-component-sidebar-submenu ${activeDropdown === 'pratibha' ? 'show' : ''}`}>
              <li><NavLink to="/pratibha-khoj/pariksha" onClick={closeMenu}>PRATIBHA KHOJ PARIKSHA</NavLink></li>
              <li><NavLink to="/pratibha-khoj/scholarship-procedure" onClick={closeMenu}>SCHOLARSHIP PROCEDURE</NavLink></li>
              <li><NavLink to="/pratibha-khoj/scholars-list" onClick={closeMenu}>SCHOLAR'S LIST</NavLink></li>
            </ul>
          </li>

          {/* Mobile Donor Dropdown */}
          <li className="navbar-component-sidebar-dropdown-item">
            <div className={`navbar-component-sidebar-toggle ${isDonorActive ? 'active' : ''}`} onClick={() => toggleDropdown('donorMenu')}>
              DONOR <FaCaretDown className={`navbar-component-drop-icon ${activeDropdown === 'donorMenu' ? 'rotate' : ''}`} />
            </div>
            <ul className={`navbar-component-sidebar-submenu ${activeDropdown === 'donorMenu' ? 'show' : ''}`}>
              <li><NavLink to="/donor" onClick={closeMenu}>DONOR</NavLink></li>
              <li><NavLink to="/protsahan-nidhi" onClick={closeMenu}>प्रोत्साहन निधि</NavLink></li>
            </ul>
          </li>
          
          {/* Mobile Media Dropdown */}
          <li className="navbar-component-sidebar-dropdown-item">
            <div className={`navbar-component-sidebar-toggle ${isMediaActive ? 'active' : ''}`} onClick={() => toggleDropdown('media')}>
              MEDIA <FaCaretDown className={`navbar-component-drop-icon ${activeDropdown === 'media' ? 'rotate' : ''}`} />
            </div>
            <ul className={`navbar-component-sidebar-submenu ${activeDropdown === 'media' ? 'show' : ''}`}>
              <li><NavLink to="/gallery" onClick={closeMenu}>GALLERY</NavLink></li>
              <li><NavLink to="/news" onClick={closeMenu}>NEWS</NavLink></li>
              <li><NavLink to="/events" onClick={closeMenu}>EVENTS</NavLink></li>
            </ul>
          </li>

          <li><NavLink to="/expenses" onClick={closeMenu} className={({ isActive }) => isActive ? "navbar-component-mobile-link active" : "navbar-component-mobile-link"}>EXPENSE</NavLink></li>
          <li><NavLink to="/contact" onClick={closeMenu} className={({ isActive }) => isActive ? "navbar-component-mobile-link active" : "navbar-component-mobile-link"}>CONTACT</NavLink></li>
        </ul>
      </div>
      
      {/* Overlay for Mobile Sidebar */}
      {menuOpen && <div className="navbar-component-overlay" onClick={closeMenu}></div>}
    </header>
  );
}

export default Navbar;